import {
  LegislativnyMaterialListApi,
  LegMaterialFilterListItem,
  LegMaterialFilterListPage,
  SortDirectionEnum,
} from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { mapStadium } from '../../model/legislativnyMaterial/StadiumMaterialu';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import LegislativnyMaterialFilterListItem from '../../model/legislativnyMaterial/LegislativnyMaterialFilterListItem';
import LegislativnyMaterialFilterListPage from '../../model/legislativnyMaterial/LegislativnyMaterialFilterListPage';

const client = new LegislativnyMaterialListApi(apiConfiguration(elegislativaPrefixPath));

const mapMaterial = (data: LegMaterialFilterListItem): LegislativnyMaterialFilterListItem => ({
  cisloLp: data.cisloLegislativnehoMaterialu,
  nazov: data.nazov,
  stadium: mapStadium(data.stadium),
  typNazov: data.typNazov,
  uuid: data.uuid,
});

const map = (data: LegMaterialFilterListPage): LegislativnyMaterialFilterListPage => ({
  materialList: data.legMaterialList.map(material => mapMaterial(material)),
  number: data.number,
  size: data.size,
  totalElements: data.totalElements,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchSledovanyLegislativnyMaterialPage = async (
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  searchText?: string,
  headers?: object,
):
  Promise<ClientResponse<LegislativnyMaterialFilterListPage>> => {
  const {
    data,
    status,
  } = await client.getSledovanyLegMaterialList(page, size, sortBy, sortDirection, searchText, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
